import {
  Dialog, DialogContent, DialogTitle, makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import tw from 'twin.macro';
import PropTypes from 'prop-types';
import { useState, memo } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import FlightSeatMap from '../FlightSeatMap';

const useStyles = makeStyles(() => ({
  dividers: {
    padding: '0',
  },
}));
const useTitleStyles = makeStyles(() => ({
  root: {
    '& .MuiTypography-root': tw`font-body`,
  },
}));

const FlightSeatMapModal = ({
  flights,
  onModalClose,
  isModalOpen,
  canPickSeat,
  defaultSelectedFlightIndex,
  defaultSelectedTravelerIndex,
}) => {
  const [selectedFlightIndex, setSelectedFlightIndex] = useState(defaultSelectedFlightIndex);
  const classes = useStyles();
  const classesTitle = useTitleStyles();

  return (
    <Dialog
      className="modal-safe-click-zone"
      open={isModalOpen}
      onClose={onModalClose}
      scroll="body"
      maxWidth="lg"
      fullWidth
      disableBackdropClick
      aria-labelledby="flight-seatmap-modal-title"
    >
      <DialogTitle id="flight-seatmap-modal-title" className="text-theme font-bold sm:text-sm xl:text-lg border-b pb-2 px-8 py-3" classes={classesTitle}>
        {canPickSeat ? 'Select your seat' : 'View Seat Availability'}
        <CloseIcon onClick={onModalClose} className="float-right font-bold cursor-pointer" />
      </DialogTitle>
      <DialogContent dividers classes={classes}>
        <div className="bg-body-0">
          <div className="text-sm font-bold text-theme flex pt-5 pl-2 overflow-x-auto sm:overflow-hidden">
            {flights.map((flight, index) => (!flight ? <></> : (
              <div
                key={flight.flightNumber}
                className={clsx({
                  'border-b-0 bg-white': flights[selectedFlightIndex] === flight,
                  'border-b': flights[selectedFlightIndex] !== flight,
                }, 'px-5 py-3 text-center border-2 rounded-md rounded-b-none')}
              >
                <button
                  type="button"
                  className="focus:outline-none h-full border-0 font-bold"
                  onClick={() => setSelectedFlightIndex(index)}
                >
                  {flight.originAirportCode}
                  {' '}
                  -
                  {' '}
                  {flight.destinationAirportCode}
                </button>
              </div>
            )))}
          </div>
        </div>
        <FlightSeatMap
          flight={flights[selectedFlightIndex]}
          canPickSeat={canPickSeat}
          onModalClose={onModalClose}
          defaultSelectedTravelerIndex={defaultSelectedTravelerIndex}
        />
      </DialogContent>
    </Dialog>
  );
};

FlightSeatMapModal.propTypes = {
  flights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onModalClose: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool,
  canPickSeat: PropTypes.bool,
  defaultSelectedFlightIndex: PropTypes.number,
  defaultSelectedTravelerIndex: PropTypes.number,
};

FlightSeatMapModal.defaultProps = {
  isModalOpen: true,
  canPickSeat: true,
  defaultSelectedFlightIndex: 0,
  defaultSelectedTravelerIndex: 0,
};

export default memo(FlightSeatMapModal);
